import _ from 'lodash';
import { getCdnImageUrl } from '../helpers/globalFunctions';
import type { Action } from '../typings/reducers';

type SiteState = {
  allCollections: any[];
  currentSite: any;
  currentSiteEditMenu: any;
  totalCollectionsCount: number;
  isLoading: boolean;
};

type SiteImage = {
  signedWilCardUrl?: string;
  cryptImageName?: string;
  isTemplateImage?: boolean;
};

export default function (
  state: SiteState = {
    allCollections: [],
    currentSite: {},
    currentSiteEditMenu: {},
    totalCollectionsCount: 0,
    isLoading: false
  },
  action: Action
): SiteState {
  switch (action.type) {
    case 'CURRENT_SITE':
      return { ...state, currentSite: action.payload };
    case 'UPDATE_CURRENT_SITE_VALUE_BY_PATH':
      const update_value_by_path = { ...state.currentSite };
      _.set(update_value_by_path, action.payload.path, action.payload.data);
      _.set(update_value_by_path, 'updated_at', Date.now());

      return { ...state, currentSite: update_value_by_path };
    case 'ALL_SITES':
      return {
        ...state,
        allCollections: action.payload.collections,
        totalCollectionsCount: action.payload.totalCollectionsCount,
        isLoading: false
      };
    case 'ALL_PANES_SITES':
      return {
        ...state,
        allCollections: _.uniqBy([...state.allCollections, ...action.payload.collections], '_id'),
        totalCollectionsCount: action.payload.totalCollectionsCount,
        isLoading: false
      };
    case 'REMOVE_SITE':
      const removeArray = state.allCollections.slice();
      _.remove(removeArray, (item) => item._id === action.payload);

      return {
        ...state,
        allCollections: [...removeArray],
        totalCollectionsCount: state.totalCollectionsCount--
      };
    case 'ADD_ICON_TO_CURRENT_SITE':
      const newGalleryArray = state.currentSite.images.slice();
      const newImage = {
        ...action.payload
      };
      newGalleryArray.splice(state.currentSite.images, 0, newImage);

      return {
        ...state,
        currentSite: {
          ...state.currentSite,
          images: [...newGalleryArray],
          updated_at: Date.now()
        }
      };
    case 'REFRESH_IMAGES_CURRENT_SITE':
      const images = (action.payload as SiteImage[]).map((img: SiteImage) => ({
        ...img,
        url: img.signedWilCardUrl
          ? img.signedWilCardUrl.replace('*', img.cryptImageName)
          : getCdnImageUrl({
              image: img as any,
              size: 'XS'
            })
      }));

      return {
        ...state,
        currentSite: { ...state.currentSite, images: [...images] }
      };
    case 'UPDATE_LOADING_STATUS':
      return {
        ...state,
        isLoading: action.payload
      };
    default:
      return state;
  }
}
